import { Image, type ImageProps } from 'antd';
import { useMemo } from 'react';
import fallbackImage from './fallback.png';

export const VideoThumbnail = (
  props: { size: number } & Omit<ImageProps, 'width' | 'height'>,
) => {
  const src = useMemo(() => {
    if (!props.src) {
      return;
    }

    if (!URL.canParse(props.src)) {
      return;
    }

    const url = new URL(props.src);

    if (!url.pathname.endsWith('.mp4')) {
      return;
    }

    if (!url.hostname.endsWith('aliyuncs.com')) {
      return;
    }

    url.searchParams.set(
      'x-oss-process',
      `video/snapshot,t_1000,f_jpg,w_${props.size * 2},m_fast`,
    );

    return url.toString();
  }, [props.src, props.size]);

  return (
    <Image
      {...props}
      classNames={{ image: 'object-cover rounded' }}
      src={src}
      preview={false}
      width={props.size}
      height={props.size}
      fallback={fallbackImage}
    ></Image>
  );
};
